async function init () : Promise<void> {
  return new Promise(resolve => {
    resolve()
  })
}

export default init
